<fc-general-filter-modal [baseId]="baseId" [form]="form" [fcFilterModalContext]="fcFilterModalContext" (apply)="save()"
  (cancel)="onCancel()" (clear)="onClear()" [disableClear]="disableClear">
  <div [formGroup]="form">
    <mat-tab-group animationDuration="0ms" mat-align-tabs="start" class="tabs-default" [disableRipple]="true"
      (selectedTabChange)="tabChanged($event)">
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Filters</span>
        </ng-template>

        <div class="emds-row">
          <div class="emds-col-12 emds-col-md-4">
            <div class="form-group">
              <label [for]="baseId + '-name'" translate>Name</label>
              <input 
              [id]="baseId + '-name'" class="form-control" type="text" formControlName="name" />
            </div>
          </div>

          <div class="emds-col-12 emds-col-md-4">
            <div class="form-group">
              <label [for]="baseId + '-attachment-type'" translate>Attachment Type</label>
              <ap-findcontrol 
                [singleSelect]="true" 
                [baseId]="baseId + '-attachment-type'" 
                [findControlId]="attachmentFindControlId"
                [apFormGroup]="form"
                [required]="false"
                [controlName]="'attachmentType'"
              >
              </ap-findcontrol>
            </div>
          </div>

          <div class="emds-col-12 emds-col-md-4">
            <div class="form-group">
              <label [for]="baseId + '-result-status'" translate>Result Status</label>
              <ap-findcontrol 
                [singleSelect]="true" 
                [baseId]="baseId + '-result-status'" 
                [findControlId]="resultStatusFindControlId"
                [apFormGroup]="form"
                [controlName]="'resultStatus'"
                [required]="false"
              >
              </ap-findcontrol>
            </div>
          </div>
        </div>

        <div class="emds-row">
          <div class="emds-col-12 emds-col-md-4">
            <div class="form-group">
              <label [for]="baseId + '-urgency'" translate>Urgency</label>
              <ap-findcontrol 
                [singleSelect]="true" 
                [baseId]="baseId + '-urgency'" 
                [findControlId]="urgencyFindControlId"
                [apFormGroup]="form"
                [controlName]="'urgency'"
                [required]="false"
              >
              </ap-findcontrol>
            </div>
          </div>

          <div class="emds-col-12 emds-col-md-4">
            <div class="form-group">
              <label [for]="baseId + '-provider'" translate>Provider</label>
              <ap-findcontrol 
                [singleSelect]="true" 
                [baseId]="baseId + '-provider'" 
                [findControlId]="providerFindControlId"
                [apFormGroup]="form"
                [controlName]="'provider'"
                [required]="false"             
              >
              </ap-findcontrol>
            </div>
          </div>

          <div class="emds-col-12 emds-col-md-4">
            <div class="form-group">
              <label [for]="baseId + '-patient'" translate>Patient</label>
              <!-- (TO:DO) need to enable the findcontrol once pre population feature available -->
              <ap-findcontrol 
                [singleSelect]="true" 
                [baseId]="baseId + '-patient'" 
                [findControlId]="patientFindControlId"
                [required]="false"
                [apFormGroup]="form"
                [controlName]="'patient'"             
                [disabled]="true"
              >
              </ap-findcontrol>
            </div>
          </div>
        </div>

        <hr>
        <div class="emds-row">
          <div class="emds-col-12 emds-col-md-4">
            <div class="form-group">
              <label [for]="baseId + '-date-type'" translate>Date Type</label>
              <ap-findcontrol 
                [singleSelect]="true" 
                [baseId]="baseId + '-date-type'" 
                [findControlId]="dateTypeFindControlId"
                [required]="false"
                [apFormGroup]="form"
                [controlName]="'dateType'"
                [requiredSearchParameters]="dateTypeSearchParameters">
              </ap-findcontrol>
            </div>
          </div>

          <div class="emds-col-12 emds-col-md-4">
            <div class="form-group">
              <label [for]="baseId + '-date-range'" translate>Date Range</label>
              <ap-timespan-find-control 
                [baseId]="baseId + '-timespan'" 
                [findControlId]="dateRangeFindControlId"
                [(selectedPk)]="dateRangePkId" 
                [(customDateRange)]="customDateRange"
                [singleSelect]="true"
                [required]="false"
                (selectedPkChange)="onTimespanChanged($event)">
              </ap-timespan-find-control>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</fc-general-filter-modal>